
import React from "react";
import { sidebarOnClicks} from "js/utilities/sdk-doc-utils";
import { Row, Col, Glyphicon } from "react-bootstrap";
import _ from "lodash";
import ApplicationTableRow from "../account/account-table-application-row";
import UserHandler from "js/utilities/user-handler";
import SDKSidebar from "js/utilities/sdk-sidebar"
import Amplitude from "js/utilities/amplitude";
import Api from "js/utilities/fnapi-client";

export default React.createClass({
  displayName : "applications",

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  isAdminRole : false,

  getInitialState() {
    let authAvailable = UserHandler.getAuthAvailable();
    if (!authAvailable){
      this.context.router.push("/signin");
    }
    return {
      authAvailable,
      // applications: [],
      loading: false,
      error: null,
      newApplication: ""
    };
  },

  componentDidMount: function() {
    sidebarOnClicks()

    this.setAllApplications();
  },

  componentWillMount() {
    if (!UserHandler.loggedIn()) {
      //return this.props.history.pushState(null, "signin");
      return this.context.router.push("/signin");
    }
    var role = UserHandler.getAuth().role;
    this.isAdminRole = (role === "owner" || role === "administrator" || role === "manager");
  },

  handleClick: function(index){
    UserHandler.setAuth(this.state.authAvailable[index]);
    this.context.router.push("/account");
  },

  handleNewApplicationChange(event) {
    this.setState({newApplication: event.target.value});
  },


  render() {
    if (!UserHandler.loggedIn()) { return false; }
    return (
      <div className="dash">
        <div className="workspace">
          <div className="workspace__container">

            <section id="Overview">
              <div className="title">
                <Glyphicon glyph="duplicate" />
                <h2>My Applications</h2>
              </div>
            </section>
            <hr />
            {(this.isAdminRole) &&
              <div>
                <section>
                  <div className="account">
                    <Row className="app header">
                      <Col md={4}>
                        <div className="header-label">Name</div>
                      </Col>
                      <Col md={5}>
                        <div className="header-label">SDK Key Identifier</div>
                      </Col>
                      <Col md={3}>
                        <div className="header-label">Action</div>
                      </Col>
                    </Row>
                    {this.state.authAvailable.map(function(auth, i) {
                      var boundClick = this.handleClick.bind(this, i);
                      return (
                        <ApplicationTableRow onClick={boundClick} key={i} title={auth.applicationName} appToken={auth.appToken}/>
                      );
                    }, this)}
                  </div>
                </section>
              </div>
            }

            <br/>
            <br/>
            {(this.state.authAvailable.length >= 2) &&
              <div>
                <section id="Overview" className="add-application">
                  <div className="title">
                    <Glyphicon glyph="plus-sign" />
                    <h2>Create New Application</h2>
                    <p>Create a new application for a new customer or distinct set of apps that you need to keep separate from your current applications.</p>
                  </div>
                  {this.state.error ? <p className="error-message">{this.state.error}</p> : <p></p> }
                  <div>
                    <form autoComplete="off" onSubmit={this.addApplication} >
                      <div><input id="input-new-application" ref="newApplication" placeholder="Enter New Application Name" type="text" value={this.state.newApplication} onChange={this.handleNewApplicationChange} /></div>
                      <br/>
                      <div>
                        <button className="btn btn-new" onClick={this.addApplication} disabled={this.state.loading ? "disabled" : ""}>
                          {!this.state.loading ? <span>Create New Application</span> : <span>Processing...</span> }
                        </button>
                      </div>
                    </form>
                  </div>
                </section>
              </div>
            }
            <SDKSidebar menuType="account" title="Applications"/>
          </div>
        </div>
      </div>
    );
  },

  setAllApplications: function() {
    Api.get("user/current/all-applications").then( (response) => {
      if(response && response.data && response.data.applicationRoles) {
        let availableApplications = UserHandler.updateAvailableApplicationsFromApiResponse(response.data.applicationRoles);
        if(availableApplications.length > 0) {
          UserHandler.setAuthAvailable(availableApplications);
          if (UserHandler.hasMultipleAuthAvailable()){
            this.setState({authAvailable: availableApplications})
          }
          else {
            // user has only one application
            alert("You have only this application");
          }
        }
      }
    });
  },

  addApplication: function(event) {

    event.preventDefault();

    let applicationData = {
      name: this.refs.newApplication.value,
    };
    if (applicationData.name.trim() === "") {
      this.setState({error: "Please enter a valid application name"});
      return
    }
    this.refs.newApplication.value = "";
    this.setState({error: null, loading: true, newApplication: ""})
    Api.post("application",applicationData).then((newApplicationResponse) => {
      Amplitude.send("application");
      //@TODO: Consider either doing this in UserHandler, or returning Role objects from POST application so we can standardize
      let auth = {
        appToken: newApplicationResponse.data.appToken,
        userToken: newApplicationResponse.data.userToken,
        applicationName: newApplicationResponse.data.name,
        applicationIcon: newApplicationResponse.data.icon,
        role: "owner",
        key: 0
      };
      this.setState({loading: false, authAvailable: this.state.authAvailable.concat([auth])});
      UserHandler.setAuthAvailable(this.state.authAvailable);
      return
    }).catch( (error) => {
      this.setState({loading: false, error: error.message});
    })
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/applications.jsx